import { Stream } from '@mi-front/ui';
import { LiveTopicsFocus } from '../../features/live-topics';
import { useLiveTopicsShow } from '../../features/live-topics/hooks/useLiveTopicsShow';
import { useFocusRange } from '../../stores/stream-screen.store';

/**
 * Renders a time-aligned stream below the focus area for track components
 * (e.g. live topics). Uses the same focus range as the focus above so tracks
 * stay aligned. Similar to AuditPreviewMarkers which renders a stream above
 * the preview.
 */
export function FocusTracks() {
  const range = useFocusRange();
  const showLiveTopics = useLiveTopicsShow();

  if (!showLiveTopics) {
    return null;
  }

  return (
    <Stream showAxis={false} height={24} range={range} renderHtml={() => <LiveTopicsFocus />} />
  );
}
